import * as React from 'react';
import { cn } from './utils';

/**
 * Base Panel component for consistent card-like containers across the app.
 * Used by ProblemTreePanel and BlockBuilder for unified styling.
 */
interface PanelProps extends React.ComponentProps<'div'> {
  /**
   * Optional wrapper for animation or additional functionality.
   * If provided, the panel styles will be applied to this wrapper.
   */
  as?: React.ElementType;
}

export const Panel = React.forwardRef<HTMLDivElement, PanelProps>(
  ({ className, as: Component = 'div', style, ...props }, ref) => {
    return (
      <Component
        ref={ref}
        className={cn('tw-rounded-2xl tw-shadow-2xl tw-relative tw-flex tw-flex-col', className)}
        style={{
          background: 'var(--card)',
          ...style,
        }}
        {...props}
      />
    );
  },
);

Panel.displayName = 'Panel';
